/** @ngInject */
export default function uiTreeModuleConfig(treeConfig) {
    treeConfig.defaultCollapsed = true;
}



// WEBPACK FOOTER //
// ./app/common/tree/tree.config.js